import dayjs from "dayjs";
import { DATE_FORMAT } from "../../constants/constants";

// this process function is using comparison and custom dashboard
export const customTrendDataProcess = (data) => {
  const customData = data?.customData;
  const customDataConfig = customData?.config;
  const digitalChs = customDataConfig?.chNo.filter((chNo, idx) => customDataConfig?.chType[idx] === "2");
  if(!customData) return [];
  const returnData = customData?.data?.map((v) => {
    const progressData = v.data.reduce((previous, current) => {
      return Object.assign(previous, {
        [String(current.chNo)]: digitalChs.includes(String(current.chNo)) ? current.status : isNaN(parseFloat(current.data)) ?  null : parseFloat(current.data)
      });
    }, {});
    return Object.assign(progressData, {dateTime: v.dateTime, localDateTime: dayjs(v.dateTime).format(DATE_FORMAT)});
  });
  const returnDataDigital = customData?.data?.map((v) => {
    const progressData = v.data.reduce((previous, current) => {
      return Object.assign(previous, {[String(current.chNo)]: current.status});
    }, {});
    return Object.assign(progressData, {dateTime: v.dateTime, localDateTime: dayjs(v.dateTime).format(DATE_FORMAT)});
  });
  return {returnData, returnDataDigital}
}